import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { captureCityStockAmountApi, payStockAmountApi } from "src/api/commonapi";
import { getSetting } from "src/api/updateSetting";
import { notification } from "src/utils/messages";

export default function WalletPayment({
  rowData,
  paymentModal,
  togglePaymentModal,
  handleCityWiseWalletList,
  filterData
}) {
  const user = JSON.parse(localStorage.getItem("userData"));
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [fileimage, setfileimage] = useState();

  const [isLoading, setIsLoading] = useState(false);

  const [walletData, setWalletData] = useState({
    date: new Date(),
    amount: 0,
    city_id: user.city_id,
    u_id: user.u_id,
    p_user_id: user.u_type == 2 ? user.p_user_id : user.u_id,
    name: user.name,
    note: "",
    stock_wallet_balance: rowData
  });
  const [loader, setLoader] = useState(false);

  const checkwallet = () => {
    let notify = notification({
      type: "error",
      message: "Our Payment Amount is greater then wallet balance"
    });
    notify();
  };

  const handleSubmitWallet = async () => {
    setLoader(true);
    let fdata = new FormData();
    Object.keys(walletData).forEach((key) => {
      if (key === "date") {
        fdata.append(
          "date",
          walletData.date !== "DD-MM-YYYY"
            ? moment(walletData.date).format("DD-MM-YYYY")
            : walletData.date
        );
      } else {
        fdata.append(key, walletData[key]);
      }
    });
    if (
      walletData.amount == undefined ||
      walletData.amount == 0 ||
      walletData.note == undefined ||
      walletData.note == "" ||
      walletData.p_screenshot == undefined
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
    } else {
      setIsLoading(true);
      const resp = await payStockAmountApi(fdata);
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status != 0) {
        setWalletData({
          date: new Date(),
          amount: "",
          city_id: user.city_id,
          u_id: user.u_id,
          name: user.name,
          note: ""
        });
        togglePaymentModal();
        setfileimage();
        handleCityWiseWalletList(filterData);
      }
    }

    setLoader(false);
  };

  // useEffect(() => {
  //   handleGetWebsetting();
  // }, []);

  return (
    <Modal
      open={paymentModal}
      onClose={() => togglePaymentModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          Add Payment
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px", marginTop: "20px" }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                required
                autoComplete="off"
                type="text"
                InputProps={{
                  startAdornment: <InputAdornment position="start">₹</InputAdornment>
                }}
                label="Payable Amount"
                name="stock_wallet_balance"
                value={rowData}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "15px" }}>
                {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  isDisabled
                  style={{ marginTop: "15px" }}
                >
                  <DatePicker
                    type="date"
                    required
                    name="date"
                    label="Date"
                    value={walletData.date ? moment(walletData.date).toDate() : new Date()}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newDate) => {
                      setWalletData({
                        ...walletData,
                        date: moment(newDate).format("YYYY-MM-DD")
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40
                          },
                          "& .MuiInputLabel-root": {
                            top: "-6px" // adjust this to move label vertically
                          }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                style={{ marginBottom: "15px" }}
                fullWidth
                autoComplete="off"
                type="number"
                label="Paying Amount"
                required
                name="amount"
                InputProps={{
                  startAdornment: <InputAdornment position="start">₹</InputAdornment>
                }}
                value={walletData?.amount}
                onKeyUp={(e) => {
                  if (parseInt(e.target.value) > parseInt(rowData)) {
                    checkwallet();
                  }
                }}
                onChange={(e) => {
                  setWalletData({
                    ...walletData,
                    amount: e.target.value != "" ? e.target.value : 0,
                    r_w_balance:
                      parseInt(walletData?.stock_wallet_balance) -
                      parseInt(e.target.value != "" ? e.target.value : 0)
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack spacing={3} style={{ marginBottom: "15px" }}>
                <TextField
                  style={{ marginTop: "0px" }}
                  fullWidth
                  autoComplete="off"
                  type="text"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>
                  }}
                  label="Remaining Wallet Balance"
                  name="r_w_balance"
                  value={parseInt(walletData?.stock_wallet_balance) - parseInt(walletData?.amount)}
                />
              </Stack>
            </Grid>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                style={{ marginTop: "0px" }}
                fullWidth
                autoComplete="off"
                type="text"
                label="Payment Note"
                required
                name="note"
                value={walletData?.note}
                onChange={(e) => {
                  setWalletData({ ...walletData, note: e.target.value });
                }}
              />
            </Grid>

            <Grid item xs={12}>
              {fileimage != undefined && (
                <img
                  src={fileimage}
                  alt="img"
                  width="100px"
                  height="80px"
                  style={{ margin: "5px" }}
                />
              )}
              <Button variant="contained" component="label">
                Upload Payment ScreenShot
                <input
                  id="file"
                  name="p_screenshot"
                  type="file"
                  hidden
                  onChange={async (event) => {
                    setWalletData({
                      ...walletData,
                      p_screenshot: event.currentTarget.files[0]
                    });
                    setfileimage(URL.createObjectURL(event.currentTarget.files[0]));
                  }}
                  className="form-control"
                />
              </Button>
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => togglePaymentModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleSubmitWallet()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
